import { useContext } from 'react';

import { OrganizationContext } from './OrganizationContext';
import { OrganizationState } from './types';

export const useOrganizations = (): OrganizationState => {
  return useContext(OrganizationContext);
};
